import { Button, Spacing, Typography } from 'enable-ui';

import { useVerifyEmailController } from '../core';

export const VerifyEmailPage = () => {
  const { isTimerRunning, timer, handleResend } = useVerifyEmailController();

  return (
    <div>
      <Spacing spacing="4xl" placement="bottom" type="margin" style={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          weight={500}
          style={{
            textAlign: 'center',
            fontSize: '26px',
            lineHeight: '36px',
            marginBottom: 12,
          }}
        >
          Check your email
        </Typography>
        <Typography style={{ fontSize: '18px', lineHeight: '26px' }}>
          We have emailed you a link to set new password.
        </Typography>
      </Spacing>

      <Button
        variant="contained"
        color="primary"
        type="submit"
        size="large"
        style={{
          width: '100%',
          fontSize: '18px',
          lineHeight: '26px',
          fontWeight: 600,
        }}
        disabled={isTimerRunning}
        onClick={() => handleResend()}
      >
        {isTimerRunning ? `Resend in ${timer}s` : 'Resend link'}
      </Button>
    </div>
  );
};
